// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"38":"5d0d34765e9c4e12b2c6","76":"7d24cd1a7aaece46dcfc"}[chunkId] + ".chunk.js";
};